//ローディング
import {loading} from "../include/module";
loading();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

//ページTOP
import {pageTop} from "../include/module";
pageTop();


// WEBPACK FOOTER //
// script.js